module.exports = __webpack_public_path__ + "logoWhite.png?05da88a7229fec4ff37f96b63f4ed5f8";